class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;

    this.detailsContainer.setAttribute('open', true);

    if (this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('empty', true);
    }

    this.summaryToggle.addEventListener('click', (event) => event.preventDefault());
  }
}
customElements.define('footer-accordion', FooterAccordion);
